<template>
  <section class="verify-password-stepper-wrapper__form ion-padding">
    <Form
      form-name="recoveryPassword"
      id="recoveryPasswordForm1"
      :validation-schema="schemaRecoveryEmail"
      @submit="handleRecoveryPasswordSubmit"
    >
      <ion-row>
        <ion-col size="12">
          <h4 class="h4 mt-8">{{ t('actions.recoveryPassword') }}</h4>
          <p class="mt-8 text-xs">{{ t('profile.recovery.description') }}</p>
          <div class="mt-32">
            <CustomInput
              form-name="recoveryPassword"
              type="text"
              :value="emailInput"
              v-model="emailInput"
              input-type="email"
              :label="t('profile.recovery.emailPlaceholder')"
              name="email"
              class-name="custom-field"
              placeholder="name@domain.com"
            />
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="mt-16">
        <ion-col size="12">
          <ion-button
            expand="block"
            color="primary"
            fill="solid"
            class="text-weight-bold"
            type="submit"
            >{{ t('actions.sendEmail') }}
          </ion-button>
        </ion-col>
      </ion-row>
    </Form>
  </section>
</template>
<script setup lang="ts">
  import { IonButton, IonCol, IonRow } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { Form } from 'vee-validate';
  import { useProfile } from '@/composables/useProfile';
  import { ref } from 'vue';
  import CustomInput from '@/components/shared/form/CustomInput.vue';
  import { useSchemas } from '@/composables/useSchemas';

  const { schemaRecoveryEmail } = useSchemas();
  const { t } = useI18n();
  const { toggleRecoveryPassword, recoveryPasswordSuccess, handleRecoveryPassword } = useProfile();

  const emailInput = ref('');

  const handleRecoveryPasswordSubmit = () => {
    handleRecoveryPassword(emailInput.value).then(() => {
      if (recoveryPasswordSuccess.value) {
        emailInput.value = '';
        toggleRecoveryPassword.value = false;
      }
    });
  };
</script>
<style scoped lang="scss">
  .change-password-stepper-wrapper {
    &__form {
      width: 100%;
      border-radius: 16px;
      background: #ffffff;
    }
  }

  .swiper {
    overflow: visible !important;
  }

  .swiper-slide-prev,
  .swiper-slide-next {
    visibility: hidden;
  }

  .dp__outer_menu_wrap,
  .dp--menu-wrapper {
    overflow: hidden;
    background: #1c4197;
  }
</style>
